import React, { Component } from 'react';
import {
    Modal, Form, Input, DatePicker, InputNumber, Radio, Button, Checkbox,
} from 'antd';
import moment from 'moment';

import AddressAutoComplete from './AddressAutocomplete';

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class UnwrappedPatientModal extends Component {
    state = {
        checked: true,
    };

    componentDidMount = () => {
        const { data } = this.props;
        const { mobile_number, contact_number } = data;
        console.log(mobile_number, contact_number);

        if (mobile_number != null && Number(mobile_number) !== Number(contact_number)) {
            this.setState({
                checked: false,
            });
        }
    };

    handleSameNumberChange = () => {
        const { checked } = this.state;
        this.setState({
            checked: !checked,
        });
    };

    fillInAddress = () => {
        const { form } = this.props;
        const { setFieldsValue, getFieldValue } = form;

        const componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            sublocality_level_2: 'long_name',
            sublocality_level_1: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'long_name',
            country: 'long_name',
            postal_code: 'short_name',
        };
        // Get the place details from the autocomplete object.
        const place = window.autocomplete.getPlace();

        setFieldsValue({ line_1: '' });
        setFieldsValue({ line_2: '' });
        setFieldsValue({ city: '' });
        setFieldsValue({ state: '' });
        setFieldsValue({ pin_code: '' });
        setFieldsValue({ country: '' });

        for (let i = 0; i < place.address_components.length; i++) {
            const addressType = place.address_components[i].types[0];
            if (addressType === 'street_number') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ line_1: val });
            } else if (addressType === 'route') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ line_2: `${val}, ` });
            } else if (addressType === 'sublocality_level_2') {
                const val = place.address_components[i][componentForm[addressType]];
                const val1 = getFieldValue('line_2');
                setFieldsValue({ line_2: `${val1 + val}, ` });
            } else if (addressType === 'sublocality_level_1') {
                const val = place.address_components[i][componentForm[addressType]];
                const val1 = getFieldValue('line_2');
                setFieldsValue({ line_2: `${val1 + val}` });
            } else if (addressType === 'locality') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ city: val });
            } else if (addressType === 'administrative_area_level_1') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ state: val });
            } else if (addressType === 'postal_code') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ pin_code: val });
            } else if (addressType === 'country') {
                const val = place.address_components[i][componentForm[addressType]];
                setFieldsValue({ country: val });
            }
        }
    }

    render() {
        const { checked } = this.state;
        const { data } = this.props;
        const {
            first_name, last_name, mobile_number, dob, age, email, sex, smart_caredose,
            contact_number, is_vip,
        } = data;

        let { addresses } = data;

        if (addresses == null) {
            addresses = [];
        }

        const {
            visible, onCancel, onCreate, form, confirmLoading,
        } = this.props;
        const { getFieldDecorator, getFieldValue } = form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 15 },
            },
        };

        const formTailLayout = {
            labelCol: { span: 24 },
            wrapperCol: { span: 15, offset: 6 },
        };

        // console.log(data);

        return (
            <Modal
                visible={visible}
                title={Object.keys(data).length === 0 ? 'Add New Patient' : 'Edit Patient'}
                style={{ textAlign: 'center', fontSize: '1.2em', top: 20 }}
                onCancel={onCancel}
                footer={[
                    <Button key="cancel" onClick={onCancel}>Return</Button>,
                    <Button key="submit" type="primary" loading={confirmLoading} onClick={onCreate}>
                        Submit
                    </Button>,
                ]}
            >

                <Form>
                    <FormItem
                        {...formItemLayout}
                        label="First Name"
                    >
                        {getFieldDecorator('first_name', {
                            rules: [{ required: true, message: 'First Name of the Patient!' }],
                            initialValue: first_name,
                        })(
                            <Input />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Last Name"
                    >
                        {getFieldDecorator('last_name', {
                            rules: [{ required: false, message: 'Last Name of the Patient!' }],
                            initialValue: last_name,
                        })(
                            <Input />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="DOB"
                    >
                        {getFieldDecorator('dob', {
                            rules: [{ required: false, message: 'DOB of the Patient!' }],
                            initialValue: dob == null ? '' : moment(dob),
                        })(
                            <DatePicker style={{ width: '100%' }} />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Age"
                    >

                        {getFieldDecorator('age', {
                            rules: [{ required: false, message: 'Please input your phone number!' }],
                            initialValue: age,
                        })(
                            <InputNumber min={1} style={{ width: '100%' }} />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Sex"
                    >
                        {getFieldDecorator('sex', {
                            rules: [{ required: true, message: 'Please select the sex of patient!' }],
                            initialValue: sex,
                        })(
                            <RadioGroup>
                                <RadioButton value="Male">Male</RadioButton>
                                <RadioButton value="Female">Female</RadioButton>
                                <RadioButton value="Transgender">Transgender</RadioButton>
                            </RadioGroup>,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Mobile No"
                    >
                        {getFieldDecorator('mobile_number', {
                            rules: [{ required: true, message: 'Please input your phone number!' },
                            {
                                validator: (rule, value, callback) => {
                                    if (value && value.toString().length !== 10) {
                                        callback('Please enter a valid 10-digit phone number!');
                                    } else {
                                        callback();
                                    }
                                }
                            }
                            ],
                            initialValue: mobile_number == null ? '' : mobile_number,
                            // initialValue: mobile_number,
                        })(
                            <InputNumber
                                style={{ width: '100%' }}
                                maxLength={10}
                            />,
                        )}
                    </FormItem>

                    <FormItem {...formTailLayout}>
                        <Checkbox
                            checked={checked}
                            onChange={this.handleSameNumberChange}
                        >
                            Same as Contact Number
                        </Checkbox>
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Contact No"
                    >
                        {getFieldDecorator('contact_number', {
                            rules: [{ required: false, message: 'Please input your phone number!' }],
                            initialValue: contact_number == null ? checked ? getFieldValue('mobile_number') : '' : contact_number,
                        })(
                            <InputNumber style={{ width: '100%' }} disabled={checked} />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Email"
                    >
                        {getFieldDecorator('email', {
                            rules: [{ required: false, message: 'Email of the Patient!' }],
                            initialValue: email,
                        })(
                            <Input />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Smart Caredose"
                    >
                        {getFieldDecorator('smart_caredose', {
                            rules: [{ required: true, message: 'Is he a smart caredose user?' }],
                            initialValue: smart_caredose == null ? '0' : smart_caredose === false ? '0' : '1',
                        })(
                            <RadioGroup>
                                <RadioButton value="1">Yes</RadioButton>
                                <RadioButton value="0">No</RadioButton>
                            </RadioGroup>,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="VIP"
                    >
                        {getFieldDecorator('is_vip', {
                            rules: [{ required: true, message: 'Is he a VIP user?' }],
                            initialValue: is_vip == null ? '0' : is_vip === false ? '0' : '1',
                        })(
                            <RadioGroup>
                                <RadioButton value="1">Yes</RadioButton>
                                <RadioButton value="0">No</RadioButton>
                            </RadioGroup>,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Whatsapp Notify"
                    >
                        {getFieldDecorator('has_whatsapp', {
                            rules: [{ required: true, message: 'Does he require whatsapp reminder?' }],
                            initialValue: 0,
                        })(
                            <RadioGroup>
                                <RadioButton value={1}>Yes</RadioButton>
                                <RadioButton value={0}>No</RadioButton>
                            </RadioGroup>,
                        )}
                    </FormItem>

                    {/* –––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––– */}

                    <h5 style={{ textAlign: 'center' }}>––––––––––––– Address –––––––––––––</h5>

                    <AddressAutoComplete
                        fillInAddress={this.fillInAddress}
                    />

                    <FormItem
                        {...formItemLayout}
                        label="Street address"
                    >
                        {getFieldDecorator('line_1', {
                            rules: [{ required: false, message: 'Line 1' }],
                            initialValue: addresses[0] == null ? '' : addresses[0].line_1,
                        })(
                            <Input />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Sublocality"
                    >
                        {getFieldDecorator('line_2', {
                            rules: [{ required: false, message: 'Line 1' }],
                            initialValue: addresses[0] == null ? '' : addresses[0].line_2,
                        })(
                            <Input />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="City"
                    >
                        {getFieldDecorator('city', {
                            rules: [{ required: false, message: 'Line 1' }],
                            initialValue: addresses[0] == null ? '' : addresses[0].city,
                        })(
                            <Input />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="State"
                    >
                        {getFieldDecorator('state', {
                            rules: [{ required: false, message: 'Line 1' }],
                            initialValue: addresses[0] == null ? '' : addresses[0].state,
                        })(
                            <Input />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Pin Code"
                    >
                        {getFieldDecorator('pin_code', {
                            rules: [{ required: false, message: 'Line 1' }],
                            initialValue: addresses[0] == null ? '' : addresses[0].pin_code,
                        })(
                            <InputNumber style={{ width: '100%' }} />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Country"
                    >
                        {getFieldDecorator('country', {
                            rules: [{ required: false, message: 'Line 1' }],
                            initialValue: addresses[0] == null ? '' : addresses[0].country,
                        })(
                            <Input />,
                        )}
                    </FormItem>

                    {/* –––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––– */}

                </Form>

            </Modal>
        );
    }
}

const AddPatientModal = Form.create()(UnwrappedPatientModal);

export default AddPatientModal;



// WEBPACK FOOTER //
// ./src/component/Users/AddPatientModal.js